module.exports = __webpack_public_path__ + "assets/img/3march_dark.249b5092.jpeg";